import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../Service/auth.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private authenticationService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;

        if (currentUser?.id) {
            if (route.data.roles) {
                //Validar que el rol enviado desde la ruta corresponda al rol del usuario
                let _rolUserSession = currentUser.roles?.[0]?.rol;
                let _rolInRoute = route.data.roles.find(x => x == _rolUserSession);
                if (_rolInRoute == undefined) {
                    /*
                    El usuario no tiene los permisos para la ruta enviada
                    entonces se manda al dashboard 
                    */
                    localStorage.setItem('status_session', '403');
                    this.router.navigate(['list-documents']);
                }
                else {
                    return true;
                }
            }
            else {
                //La ruta no cuenta con roles establecidos
                this.router.navigate(['/login']);
            }
        }
        else {
            console.log("No hay usuario en sesión");
        }

        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
